import { render, staticRenderFns } from "./contractPartyaManageList.vue?vue&type=template&id=67b63203&scoped=true"
import script from "./contractPartyaManageList.vue?vue&type=script&lang=js"
export * from "./contractPartyaManageList.vue?vue&type=script&lang=js"
import style0 from "./contractPartyaManageList.vue?vue&type=style&index=0&id=67b63203&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b63203",
  null
  
)

export default component.exports